import css from 'styled-jsx/css';

export default css`
  .AmpOutbrain {
    display: grid;
    grid-template-columns: 1fr 350px 1fr;
  }

  .AmpOutbrain amp-embed {
    grid-column: 2 / 3;
  }
`;
